var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "#ECECEC",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49948 0.964311C4.5 0.964311 5.3622 1.5 5.3622 2.49986V4H1.63736L1.6375 2.5C1.6375 1.5 2.49897 0.964311 3.49948 0.964311ZM6.23783 4.02506L6.23797 2.5C6.23797 0.964311 5 0 3.50012 0C2.00024 0 0.763136 0.964311 0.763136 2.5L0.762995 4.02506C0.335123 4.08774 0 4.47539 0 4.9643L4.98127e-05 8.0357C4.98127e-05 8.56896 0.392047 9 0.875043 9H6.12501C6.608 9 7 8.56896 7 8.0357L6.99995 4.9643C6.99995 4.47539 6.6657 4.08774 6.23783 4.02506Z"
  })));
};
export default SvgLocked;